module.exports = __webpack_public_path__ + "static/img/ai_robot.0072978.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/ai_robot.png
// module id = VLQE
// module chunks = 7